module.exports = __webpack_public_path__ + "img/vue-js.69cedcf3.svg";